import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Landing from "./components/Home/Landing";
import Dashboard from "./components/Dashboard/Dashboard";
import JobSearch from "./components/Job_Search/JobSearch";
import Navbar from "./components/Home/Navbar";
import Footer from "./components/Home/Footer";
import HomeLogin from "./components/LoginSignup/HomeLogin";
import HomeRegister from "./components/LoginSignup/HomeRegister";
import EmployerLogin from "./components/Employer/EmployerLogin";
import EmployerEnquiry from "./components/Employer/EmployerEnquiry";
import ForgotPassword from "./components/Forget_Password/ForgotPassword";
import EmployerRegistrationForm from "./components/Employer/EmployerRegistration";
import Employerdb from "./components/Job_Card/Employerdb";
import ELanding from "./components/EmpLanding/ELanding";
import FeedbackForm from "./components/FooterLink/FeedbackForm";
import {jobData} from './components/EmpLanding/DataBase'
import Company from './components/Company/Company'
import Contact1 from "./components/Contact/Contact1";
import BuyPlan from "./components/BuyPlan/BuyPlan";

function App() {
  return (
    <Router>
      <Content />
    </Router>
  );
}

function Content() {
  const location = useLocation();

  // Paths where Footer should not be displayed
  const noFooterRoutes = ["/EmployerLogin", "/EmployerEnquiry", "/HomeLogin", "/HomeRegister", "/ForgotPassword", "/Employerdb","/Feedback"];
  const hideFooter = noFooterRoutes.includes(location.pathname);

  // Paths where Navbar should not be displayed
  const noNavbarRoutes = ["/Employerdb", "/Dashboard", "/ELanding"];
  const hideNavbar = noNavbarRoutes.includes(location.pathname);

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/apply" element={<JobSearch jobs={jobData} />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/HomeLogin" element={<HomeLogin />} />
        <Route path="/HomeRegister" element={<HomeRegister />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/EmployerLogin" element={<EmployerLogin />} />
        <Route path="/EmployerEnquiry" element={<EmployerEnquiry />} />
        <Route path="/EmployerRegistrationForm" element={<EmployerRegistrationForm />} />
        <Route path="/Employerdb" element={<Employerdb />} />
        <Route path="/ELanding" element={<ELanding jobs={jobData}/>} />
        <Route path="/Feedback" element={< FeedbackForm/>} />
        <Route path="/company" element={<Company/>} />
        <Route path="/Contact1" element={< Contact1/>} />
        <Route path="/BuyPlan" element={< BuyPlan/>} />

        <></>
      </Routes>
      {!hideFooter && <Footer />}
    </>
  );
}

export default App;
